import './PageNotFound.scss';

import React from 'react';

import LogoText from '../../assets/images/LandingPage/LocalFlirt-red-logo-black.svg';
import {
  showMembersAreaPage,
  showRootPage
} from '../../services/navigation-service/navigation.service';
import { getToken } from '../../services/token-service/token.service';
import { getUserData } from '../../services/user-service/user.service';

const PageNotFound = () => {
  const isLoggedIn = Boolean(getToken() && getUserData());

  const handleButtonClick = () => {
    if (isLoggedIn) {
      showMembersAreaPage();
    } else {
      showRootPage();
    }
  };

  const buttonText = isLoggedIn ? 'TAKE ME BACK TO HOMEPAGE' : 'GO TO LOGIN PAGE';

  return (
    <div className="not-found">
      <div className="not-found-header">
        <img src={LogoText} alt="LocalFlirt" className="logo" />
      </div>
      <div className="not-found-content">
        <div className="error-number">404</div>
        <div className="error-title">Page is not found</div>
        <div className="error-message">
          You've wandered off the dating trail! Let's get you back on track :)
        </div>
        <button className="back-button" onClick={handleButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
